import { useQuery } from "react-query";
import { ReferentialApi } from "../../api";
import { useApiService } from "../useApiService";

export function useGenderRef() {
  const api = useApiService(ReferentialApi);
  const { data, isFetching, refetch } = useQuery(
    "genders",
    async () => {
      return await api.genders();
    },
    { staleTime: Infinity }
  );

  return {
    genders: data ?? [],
    gendersLoading: isFetching,
    refetchGendersRef: refetch,
  };
}
